import db from "../db/database";
import {
    fetchFromBusinessCentral,
    sendToBusinessCentral,
} from "../utils/businessCentralUtils";
import { getPendingSync, isOnline } from "./syncService";

// Función para transformar un turno al formato esperado por Business Central
const transformTurnoForBC = (turno) => {
    // Transformar el turno al formato esperado por BC
    const transformedTurno = {
        No: turno.No || "TEMP", // Si no tiene No, usamos TEMP para que BC asigne uno
        DescripcionTurno: turno.DescripcionTurno, // Enviamos DescripcionTurno como Turno a BC
        HorarioInicio: turno.HorarioInicio,
        HorarioFin: turno.HorarioFin || "",
        Deleted: turno.deleted,
    };

    // Crear el formato final esperado por el endpoint
    return {
        data: JSON.stringify({ Turnos: [transformedTurno] }),
    };
};

export const syncTurnos = async () => {
    if (!isOnline()) {
        return false;
    }

    try {
        const pendingTurnos = await getPendingSync("turnos");

        // Enviar turnos pendientes uno por uno
        if (pendingTurnos.length > 0) {
            console.log(`Sincronizando ${pendingTurnos.length} turnos pendientes...`);

            for (const turno of pendingTurnos) {
                try {
                    // Si el turno está marcado como eliminado, lo eliminamos directamente
                    if (turno.deleted) {
                        await db.turnos.delete(turno.id);
                        continue;
                    }

                    // Enviar turno individual a Business Central
                    const response = await sendToBusinessCentral(
                        "Importaciones_insertaTurnos",
                        transformTurnoForBC(turno),
                        true
                    );

                    // Verificar respuesta y actualizar el turno con el No asignado por BC
                    if (response && response.value) {
                        const turnoNo = response.value;

                        console.log(`Turno ${turno.DescripcionTurno} (ID: ${turno.id}) sincronizado con No: ${turnoNo}`);

                        // Actualizar el turno local con el No de BC
                        await db.turnos.update(turno.id, {
                            No: turnoNo,
                            lastModified: new Date(),
                            lastSynced: new Date(),
                            pendingSync: 0,
                        });

                    } else {
                        console.error(`Error al sincronizar turno ${turno.id}: Respuesta inválida de BC`);
                    }
                } catch (error) {
                    console.error(`Error al sincronizar turno ${turno.id}:`, error);
                }
            }
        }

        // Obtener turnos del servidor después de sincronizar los pendientes
        const serverTurnos = await fetchFromBusinessCentral("Turnos");
        const localTurnos = await db.turnos.toArray();

        // Mapa para buscar turnos locales por descripción rápidamente (ya que BC usa "Turno" como nombre del campo)
        const localTurnosByDesc = {};
        localTurnos.forEach(turno => {
            if (turno.DescripcionTurno) {
                localTurnosByDesc[turno.DescripcionTurno] = turno;
            }
        });

        // Actualizar turnos existentes y añadir nuevos desde el servidor
        for (const serverTurno of serverTurnos) {
            // Verificar si el turno ya existe localmente por descripción
            const localTurno = localTurnosByDesc[serverTurno.Turno];

            if (localTurno) {
                // Actualizar turno existente si no está pendiente de sincronización
                if (localTurno.pendingSync === 0) {
                    await db.turnos.update(localTurno.id, {
                        HorarioInicio: serverTurno.HorarioInicio,
                        HorarioFin: serverTurno.HorarioFin,
                        No: serverTurno.No, // Actualizar el No asignado por BC
                        lastModified: new Date(),
                        lastSynced: new Date(),
                    });
                }
            } else {
                // Añadir nuevo turno del servidor si no existe localmente
                await db.turnos.add({
                    DescripcionTurno: serverTurno.Turno, // Guardamos el Turno del servidor como DescripcionTurno
                    No: serverTurno.No, // Guardar el No asignado por BC
                    HorarioInicio: serverTurno.HorarioInicio,
                    HorarioFin: serverTurno.HorarioFin,
                    lastSynced: new Date(),
                    pendingSync: 0,
                    deleted: false,
                });
            }
        }

        return true;
    } catch (error) {
        console.error("Error al sincronizar turnos:", error);
        return false;
    }
};